import { render, staticRenderFns } from "./product-matching.vue?vue&type=template&id=3ca3d39e&scoped=true&"
import script from "./product-matching.vue?vue&type=script&lang=js&"
export * from "./product-matching.vue?vue&type=script&lang=js&"
import style0 from "./product-matching.vue?vue&type=style&index=0&id=3ca3d39e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca3d39e",
  null
  
)

export default component.exports